import ResourceApi from '../ResourceApi';

const CandidateResource = {
  index: async (params = {}) => (await ResourceApi.get('/resource/candidates', { params })).data,
  get: async (id) => (await ResourceApi.get(`/resource/candidates/${id}`)).data,
  statuses: async (params = {}) => (await ResourceApi.get('/resource/candidates/statuses', params)).data,
  vacancy: async (id) => (await ResourceApi.get(`/resource/vacancy/${id}`)).data,
  vacancies: async () => (await ResourceApi.get('/resource/vacancy')).data,
};

export default CandidateResource;
